// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-viewer/" + ({"3262":"UpgradeModal","8631":"AdditionalInfoStep-AdditionalInfoStep"}[chunkId] || chunkId) + ".chunk.min.css";
};